import { commonCarouselSettings } from 'src/lib/constants';
import { AppRoutes } from 'src/lib/routes';
import Link from 'next/link';
import { BsStarFill } from 'react-icons/bs';
import pluralize from 'pluralize';
import Slider from 'react-slick';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { Review } from 'src/types';
import ReadMore from './ReadMore';

const WhatOtherGuestsSay: React.FC<{
  reviews: Review[];
  ratedReviewsCount?: number;
  reviewRating?: number;
}> = ({ reviews, ratedReviewsCount, reviewRating }) => {
  return reviews.length > 0 && ratedReviewsCount ? (
    <div className="tw-bg-brand-navy tw-py-16 md:tw-py-24">
      <div className="container">
        <div className="tw-text-brand-green tw-font-styleSans tw-text-center tw-font-semibold tw-text-5xl md:tw-text-6xl md:tw-leading-none tw-leading-none tw-w-72 tw-px-1 md:tw-w-full tw-mx-auto">
          What other guests say
        </div>

        <div className="tw-flex tw-items-center tw-justify-center tw-text-white tw-my-8 md:tw-my-10">
          <div className="tw-font-semibold tw-mr-1">
            <span className="tw-leading-none">{reviewRating}</span>
          </div>
          <BsStarFill size={16} className="tw-text-orange tw-align-middle" />
          <div className="tw-text-white tw-mx-2">|</div>
          <div>{pluralize('review', ratedReviewsCount, true)}</div>
        </div>

        <Slider
          {...commonCarouselSettings}
          prevArrow={
            <div className="slick-prev">
              <HiOutlineArrowNarrowLeft
                size={24}
                strokeWidth={2}
                className="tw-text-white hover:tw-text-brand-green"
              />
            </div>
          }
          nextArrow={
            <div className="slick-next">
              <HiOutlineArrowNarrowRight
                size={24}
                strokeWidth={2}
                className="tw-text-white hover:tw-text-brand-green"
              />
            </div>
          }
          slidesToShow={3}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1,
              },
            },
          ]}
          className="tw--mx-3.75 slider-v2"
        >
          {reviews.map((review, index) => (
            <div className="tw-px-3.75" key={index}>
              <div className="tw-p-8 tw-bg-brand-navy tw-rounded-lg tw-border tw-border-brand-green tw-text-center">
                <div className="tw-text-center tw-mb-4 tw-leading-none">
                  {[...Array(review.rating)].map((key) => (
                    <BsStarFill
                      key={key}
                      width={20}
                      height={20}
                      className="tw-text-orange tw-align-top tw-mx-1"
                    />
                  ))}
                </div>
                <div className="tw-font-styleSans tw-text-white tw-font-semibold tw-text-lg md:tw-text-2xl tw-leading-none md:tw-leading-none tw-h-28 md:tw-h-32 tw-mb-2">
                  <ReadMore
                    mobileLength={180}
                    desktopLength={108}
                    as="div"
                    className=""
                    content={review.strippedBody || ''}
                    dotOnly={true}
                  />
                </div>
                <div className="tw-text-white tw-font-semibold tw-text-center tw-mb-4 md:tw-mb-8 tw-leading-none tw-text-sm">
                  {review.reviewer}
                </div>
                {review.option ? (
                  <div className="tw-h-10">
                    <span className="tw-font-semibold tw-text-white tw-text-sm">Booked:</span>{' '}
                    <Link
                      legacyBehavior
                      href={AppRoutes.experienceRoute({ id: review.option.slugCode }).toPath()}
                    >
                      <a className="tw-text-white tw-underline tw-text-sm">{review.option.name}</a>
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </Slider>
        <div className="tw-pb-10"></div>
      </div>
    </div>
  ) : null;
};

export default WhatOtherGuestsSay;
